import http from '../http'

/**
 * 获取内容
 * @param  {number} id 内容主键
}
 */
export const getContent = id => {
    return http.get(`/api/gm/content/get/${id}`)
}
/**
 * 获取列表
 * @param {object} search 传入的值,例:  {
        productid: 产品主键,
        relationid: 关联主键,
        relationmodel: 类型,
        isdelete: 是否删除
}
*/
export const getList = search => {
    return http.get('/api/gm/content/getlist', { params: search })
}
/**
 * 获取列表第一项
 * @param {object} search 传入的值,例:  {
        productid: 产品主键,
        relationid: 关联主键,
        relationmodel: 类型,
        isdelete: 是否删除
}
 */
export const getListFirst = search => {
    return http.get('/api/gm/content/getlistfirst', { params: search })
}

/**
 * 添加内容
 * @param {FormData} content 内容,例:  {
    "id": 0,
    "name": '产品名',
    "image": "图片",
    "CatalogTree":[
    {
    "id":0,
    "label":"名称",
    "type":"类型名",
    "childs":[],
    },
    ]
}
*/
export const addContent = content => {
    return http.post('/api/gm/content/add', content)
}
/**
 * 修改内容
 * @param {FormData} content 内容,例:  {
    "id": 0,
    "name": '产品名',
    "image": "图片",
    "CatalogTree":[
    {
    "id":0,
    "label":"名称",
    "type":"类型名",
    "childs":[],
    },
    ]
}
*/
export const editContent = content => {
    return http.post('/api/gm/content/edit', content)
}
/* 修改排序
* @param {object} sortarr 用户,例:  [{
   "id": 0,
   "sort": 0,
  }]
*/
export const editSort = sortarr => {
    return http.post('/api/gm/content/sort', sortarr)
}
/**
 * 删除
 * @param {array} ids 主键集合, 例: [100, 101]
 */
export const deleteContents = ids => {
    return http.delete('/api/gm/content/delete', { data: ids })
}




// WEBPACK FOOTER //
// ./src/api/gm/api-content.js